import { Component, Input } from '@angular/core';

@Component({
  selector: 'object-renderer',
  templateUrl: './object-renderer.component.html',
  styleUrls: ['./object-renderer.component.scss']
})
export class ObjectRendererComponent {
  Object = Object;
  @Input() object: any;
  get type() { return typeof this.object; }
}
